// store/stripePaymentSlice.ts
import { StripeFixedFormFeilds, StripeForm } from '@/pages/payments/interface';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';


interface StripePaymentState {
    spiritList: StripeForm[];
    fixedForm: Partial<StripeFixedFormFeilds>;
}

const initialState: StripePaymentState = {
    spiritList: [],
    fixedForm: {},
};

const paymentFormSlice = createSlice({
    name: 'paymentForm',
    initialState,
    reducers: {
        setSpiritList(state, action: PayloadAction<StripeForm[]>) {
            state.spiritList = action.payload;
        },
        setFixedForm(state, action: PayloadAction<Partial<StripeFixedFormFeilds>>) {
            state.fixedForm = { ...state.fixedForm, ...action.payload };
        },
        resetPaymentForm(state) {
            state.spiritList = [];
            state.fixedForm = {};
        },
        resetPaymentFixedFormValues(state) {
            const { store_name, store_location } = state.fixedForm;
            state.fixedForm = { store_name, store_location };
        },
    },
});

export const { setSpiritList, setFixedForm, resetPaymentForm, resetPaymentFixedFormValues } = paymentFormSlice.actions;
export default paymentFormSlice.reducer;
